/*
 * This file is part of glowingblue/orell-rezensionen.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import Component, { type ComponentAttrs } from 'flarum/common/Component';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import type Mithril from 'mithril';
import type ReviewListState from '../states/ReviewListState';

export interface ReviewsExportStatusAttrs extends ComponentAttrs {
	state: ReviewListState;
}

export default class ReviewsExportStatus extends Component<ReviewsExportStatusAttrs> {
	oninit(vnode: Mithril.Vnode<ReviewsExportStatusAttrs, this>) {
		super.oninit(vnode);
	}

	view(): Mithril.Children {
		let { selectedCount, selectableCount, exportingInProgress, toExportCount, successCount, failedCount } = this.attrs.state;

		return (
			<div className="ReviewsExportStatus">
				{typeof toExportCount === 'undefined' ? (
					<div className="ReviewsExportStatus-selected">
						{app.translator.trans('glowingblue-orell-rezensionen.forum.export.status.selected', {
							selected: selectedCount,
							total: selectableCount,
						})}
					</div>
				) : (
					<>
						<div className={`ReviewsExportStatus-progressBar ${exportingInProgress ? 'inProgress' : ''}`}>
							<div
								className="ReviewsExportStatus-progressBar-fill"
								style={{
									// `ReviewListState` sets all three counters together, so they are non-null here.
									width: `${((successCount! + failedCount!) / toExportCount) * 100}%`,
								}}
							></div>

							<span className="ReviewsExportStatus-progressBar-fill-text">{`${successCount! + failedCount!} / ${toExportCount}`}</span>

							{exportingInProgress && <LoadingIndicator size="tiny" display="inline" />}
						</div>
						<div className="ReviewsExportStatus-progressBar-text">
							<div className="exportSuccess">
								{app.translator.trans('glowingblue-orell-rezensionen.forum.export.status.progress_success', {
									success: successCount,
									total: toExportCount,
								})}
							</div>

							{!!failedCount && (
								<div className="exportFailed">
									{app.translator.trans('glowingblue-orell-rezensionen.forum.export.status.progress_failed', {
										failed: failedCount,
									})}
								</div>
							)}
						</div>
					</>
				)}
			</div>
		);
	}
}
